﻿import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {UIText} from "../Tools/Base/UIText";
import {UIBase} from "../Tools/Base/UIBase";
import {Core} from "../../Base/Core";
import {NUtils} from "../../Utils/NUtils";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";
import {UINineSlice} from "../Tools/Base/UINineSlice";
import {UISprite} from "../Tools/Base/UISprite";
import {UILabeledIcon} from "../Tools/Base/UILabeledIcon";
import {MissionRewards} from "../Tools/Mission/MissionRewards";

class MissionListItem extends UIBase {
    Awake() {
        super.Awake();
        this.missionId = 0; // int
        this.back = this.addChild(new UINineSlice("bg-simple"));
        this.back.tint = 0x000000;
        this.back.alpha = 0.3;

        this.startBtn = this.addChild(new UINineSliceButton("btn-green", Core.Localizator.Get("start")));
        this.timeField = this.addChild(
            new UILabeledIcon({
                label: "",
                icon: "ico-clock",
                iconAlign: "absolute-left",
                iconSize: 1.4,
                backgroundColor: 0x000000,
                backgroundAlpha: 0.3,
                textProps: {
                    fitTextTemplate: "00h 00m 00s",
                },
            })
        );

        this.timeField._label.anchor.set(0, 0.5);

        this.rewards = this.addChild(new MissionRewards());
        this.nameField = this.addChild(new UIText());
        this.nameField.anchor.set(0, 0.5);
        this.iconImage = this.addChild(new UISprite("rocket-noflame"));

        this.startBtn.on("pointertap", () => {
            Core.Player.PlanetsSave.TutorSave.mission = true;
            Core.UI.tutorial.HideObjectHand(this.startBtn);

            Core.Player.Missions.CreateMission(this.missionId);
            Core.UI.missionsList.Hide();
            Core.UI.missionActive.Show();
        });
    }

    Init(missionData) {
        this.missionId = missionData.id;
        this.rewards.Init(missionData.rewards);
    }

    UpdateUI() {
        this.SetActive(Core.Player.Missions.IsTutorial() ^ (this.missionId != 1));
        let missionData = Core.GameData.Missions.GetMission(this.missionId);
        this.nameField.text = Core.Localizator.Get(missionData.missionName);
        this.timeField.text = NUtils.FormatSecondsToTime(missionData.durationSeconds);
        this.rewards.UpdateUI();

        if (this.Active && Core.Player.PlanetsSave.TutorSave.step === 10) {
            Core.UI.tutorial.ShowObjectHand(this.startBtn);
        }
    }

    fitLayout(parentRect) {
        this.position.copyFrom(parentRect);

        let rect = parentRect.clone();
        rect.x = rect.y = 0;
        this.back.fitLayout(rect);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.2;
        rect.height = parentRect.height * 0.55;
        rect.x = parentRect.width * 0.02;
        rect.y = parentRect.height * 0.07;
        this.iconImage.fitRect(rect);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.46;
        rect.height = parentRect.height * 0.19;
        rect.x = parentRect.width * 0.23;
        rect.y = parentRect.height * 0.12;
        this.nameField.fitLayout(rect);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.48;
        rect.height = parentRect.height * 0.19;
        rect.x = parentRect.width * 0.23;
        rect.y = parentRect.height * 0.37;
        this.timeField.fitLayout(rect);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.26;
        rect.height = parentRect.height * 0.48;
        rect.x = parentRect.width * 0.72;
        rect.y = parentRect.height * 0.12;
        this.startBtn.fitLayout(rect);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.96;
        rect.height = parentRect.height * 0.25;
        rect.x = parentRect.width * 0.02;
        rect.y = parentRect.height * 0.67;
        this.rewards.fitLayout(rect);
    }
}

export class UIMissionsList extends UICommonPopup {
    Awake() {
        super.Awake({
            title: Core.Localizator.Get("missions"),
            closeButton: true,
        });
        this.items = []; // MissionListItem[] items;
        this.subtitle = this.content.addChild(new UIText(Core.Localizator.Get("your_missions_simple"), { fill: 0xCCCCCC }));
    }

    Init() {
        super.Init();
        for (let missionData of Core.GameData.Missions.missions) {
            let item = this.content.addChild(new MissionListItem());
            item.Init(missionData);
            this.items.push(item);
        }
    }

    Show() {
        this.subtitle.text = Core.Localizator.Get(Core.Player.Missions.IsTutorial() ? "your_missions_tutorial" : "your_missions_simple");
        this.fitLayout();
        for (let item of this.items) {
            item.UpdateUI();
        }
        super.Show();
    }

    fitItems(rect) {
        let items = this.items.filter((item) => item.Active);
        let padding = rect.width * 0.05;

        let itemRect = rect.clone();
        itemRect.height = (itemRect.height - padding * 2) / 3;
        itemRect.y = rect.y;

        for (let item of items) {
            item.fitLayout(itemRect);
            itemRect.y += itemRect.height + padding;
        }
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 1.7;
        let w = Math.min(viewport.width * 0.9, (viewport.height * 0.85) / sideRatio);
        let h = w * sideRatio;

        this.setPopupSize(w, h);

        super.fitLayout(viewport);

        let contentRect = this.getContentSize();

        let rect = contentRect.clone();
        rect.width = contentRect.width * 0.4;
        rect.height = contentRect.height * 0.05;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.125;
        this.subtitle.fitLayout(rect);

        rect = contentRect.clone().pad(-contentRect.width * 0.05, -contentRect.height * 0.11);
        rect.y = contentRect.width * 0.18 + rect.width * 0.15;
        this.fitItems(rect);
    }
}
